import { extendTheme } from '@chakra-ui/react';

const theme = {
    baseStyle: {
        fontWeight: 'semibold',
    },
    sizes: {
        xl: {
            h: '56px',
            fontSize: 'md',
            px: '32px',
            py: '6px'
        },
        lg: {
            h: '48px',
            fontSize: 'md',
            fontWeight: 'sm',
            px: '32px',
            py: '6px'
        },
        md: {
            h: '40px',
            fontSize: 'sm',
            px: '24px',
            py: '6px'
        }
    },
    variants: {
        primary: (props: any) => ({
            bg: props.colorMode === 'dark' ? 'teal.300' : 'primary.500',
            color: '#ffffff',
            _hover: {
                bg: 'primary.700',
                _disabled: {
                    bg: 'primary.700'
                }
            },
            _focus: {
                boxShadow: 'none'
            }
        }),
    },
    defaultProps: {
        size: 'md',
        //colorScheme: 'primary',
        variant: 'primary',
    }
};

export default theme